import React from "react";
import { Layout, Avatar, Button, Typography, Space } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Menu from "./Menu";
import Breadcrumb from "./Breadcrumb";
const { Header, Content, Footer } = Layout;
const { Text } = Typography;

const AppLayout = (props) => {
  const { authUser } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    navigate("/logout");
  };
  return (
    <Layout className="layout">
      <Header>
        <div className="logo">Your Space</div>
        <Menu />
        <Space>
          <Avatar
            style={{ backgroundColor: "#87d068" }}
            src="https://joeschmoe.io/api/v1/random"
          />
          <Text style={{ color: "#fff" }}>{authUser?.email}</Text>
          <Button type="link" onClick={handleLogout}>
            <u>Logout</u>
          </Button>
        </Space>
      </Header>
      <Content
        style={{
          padding: "0 50px",
        }}
      >
        <Breadcrumb />
        <div className="site-layout-content">
          <Outlet />
        </div>
      </Content>
      <Footer
        style={{
          textAlign: "center",
        }}
      >
        ©2022 Created by NAD
      </Footer>
    </Layout>
  );
};
export default AppLayout;
